import { useEffect } from 'react';
import type { UseFormSetError, UseFormSetValue } from 'react-hook-form';
import type { SignupFormStateType } from '../SignupIndex';

const RESTORABLE_FIELDS: ReadonlyArray<keyof SignupFormStateType> = [
  'mailAddress',
  'fullName',
  'companyName',
  'tel',
  'zipCode',
  'prefectureDiv',
  'city',
  'address',
  'buildingName',
];

export function useSignupFormRestore(
  setValue: UseFormSetValue<SignupFormStateType>,
  setFormError: UseFormSetError<SignupFormStateType>
): void {
  useEffect(() => {
    const duplicatedErrorMessage = sessionStorage.getItem('duplicatedError');
    if (duplicatedErrorMessage) {
      setFormError('companyName', {
        type: 'custom',
        message: duplicatedErrorMessage,
      });
      sessionStorage.removeItem('duplicatedError');
    }
    const savedFormData = sessionStorage.getItem('signupFormData');
    if (savedFormData) {
      try {
        const parsed = JSON.parse(savedFormData) as Partial<SignupFormStateType>;
        RESTORABLE_FIELDS.forEach(field => {
          const value = parsed[field];
          if (value !== undefined) {
            setValue(field, value ?? '');
          }
        });
        sessionStorage.removeItem('signupFormData');
      } catch (e: unknown) {
        console.error('Failed to restore form data:', e);
        sessionStorage.removeItem('signupFormData');
      }
    }
  }, [setValue, setFormError]);
}
